/**
 * Store Provider
 * Wraps the app with Redux store
 */

import { Provider } from 'react-redux';
import { store } from '@/store';

interface StoreProviderProps {
    children: React.ReactNode;
}

export function StoreProvider({ children }: StoreProviderProps) {
    return <Provider store={store}>{children}</Provider>;
}

export default StoreProvider;
